import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Header from "./Header";
import Body from "./Body";
import Hero from "./Hero";
import Footer from "./Footer";

import "aos/dist/aos.css";
import AOS from "aos";

const Principal = () => {
  useEffect(() => {
    // Inicializa AOS cuando el componente se monta
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Lumière Tica | Velas Aromáticas Artesanales en Costa Rica
        </title>

        <meta
          name="description"
          content="Descubre las velas aromáticas artesanales de Lumière Tica. Diseños especiales para regalar, decorar y crear momentos únicos en Costa Rica."
        />

        <link
          rel="canonical"
          href="https://lumieretica.com/"
        />

        <meta
          property="og:title"
          content="Lumière Tica | Velas Aromáticas Artesanales"
        />

        <meta
          property="og:description"
          content="Descubre nuestra exclusiva colección de velas aromáticas artesanales. Luz que abraza tus sentidos."
        />

        <meta
          property="og:url"
          content="https://lumieretica.com/"
        />
      </Helmet>

      <Header />
      <Hero />
      <Body />
      <Footer />
    </>
  );
};

export default Principal;